import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {tap, catchError } from 'rxjs/operators';

import { NotificationService } from '../main/shared/notification.service';
//import { debug } from 'util';

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
    message: string;
    constructor(
        private notifyService: NotificationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //
        return next.handle(request).pipe(
            tap(response => {
               if(response.type != 0){
                var _response= (<HttpResponse<any>>response);
                if(_response.body != null){
                var message = _response.body.Message != "" ?  _response.body.Message : "Data added successfully.";
                if(_response.status == 201) {
                    this.notifyService.showSuccess(message, 'Success');
                }
                }
               }
              }),
        );
    }
}
